import '../../assets/vendor/line-awesome/dist/line-awesome/css/line-awesome.min.css';

export const LineAwesomeIcon = ({ name, className = '' }: { name: string; className?: string }) => {
  const classNameAppended = `las la-${name} ${className}`;
  return <i className={classNameAppended} />;
};
